import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-input',
    templateUrl: './input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputComponent implements OnInit {
  @Input() placeholder: string = "";
  @Input() label?: string;
  @Input() type: string = 'text';
  @Input() required: boolean = true;
  @Input() class?: string;
  @Input() pattern: string = "";
  @Input() model?: any;
  @Input() disabled: boolean = false;
  @Input() iconPlace?: string;
  @Input() icon?: string;

  @Output() onChanges = new EventEmitter<any>();
  inputType: any;

  hide: boolean = false;
  constructor() {}

  ngOnInit() {
    this.hide = this.type === 'password' ? true : false;
    this.inputType = this.type;
  }

  showHidePass($event: any) {
    this.hide = this.hide ? false : true;
    this.type = this.hide ? 'password' : 'text';
  }
  onModelChange(e: any) {
    this.onChanges.emit(e);
  }
}
